var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 30,
    viewBox: "0 0 37 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "basil:menu-solid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4466 15C30.4466 14.7099 30.3248 14.4317 30.108 14.2266C29.8911 14.0215 29.597 13.9062 29.2904 13.9062H7.70703C7.40037 13.9062 7.10628 14.0215 6.88944 14.2266C6.6726 14.4317 6.55078 14.7099 6.55078 15C6.55078 15.2901 6.6726 15.5683 6.88944 15.7734C7.10628 15.9785 7.40037 16.0937 7.70703 16.0937H29.2904C29.597 16.0937 29.8911 15.9785 30.108 15.7734C30.3248 15.5683 30.4466 15.2901 30.4466 15ZM30.4466 7.70831C30.4466 7.41823 30.3248 7.14003 30.108 6.93491C29.8911 6.7298 29.597 6.61456 29.2904 6.61456H7.70703C7.40037 6.61456 7.10628 6.7298 6.88944 6.93491C6.6726 7.14003 6.55078 7.41823 6.55078 7.70831C6.55078 7.99839 6.6726 8.27659 6.88944 8.48171C7.10628 8.68683 7.40037 8.80206 7.70703 8.80206H29.2904C29.597 8.80206 29.8911 8.68683 30.108 8.48171C30.3248 8.27659 30.4466 7.99839 30.4466 7.70831ZM30.4466 22.2916C30.4466 22.0016 30.3248 21.7234 30.108 21.5182C29.8911 21.3131 29.597 21.1979 29.2904 21.1979H7.70703C7.40037 21.1979 7.10628 21.3131 6.88944 21.5182C6.6726 21.7234 6.55078 22.0016 6.55078 22.2916C6.55078 22.5817 6.6726 22.8599 6.88944 23.065C7.10628 23.2702 7.40037 23.3854 7.70703 23.3854H29.2904C29.597 23.3854 29.8911 23.2702 30.108 23.065C30.3248 22.8599 30.4466 22.5817 30.4466 22.2916Z",
    fill: "#C67878"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.be15693553b9837a1af20cc2aff73b9d.svg";
export { ForwardRef as ReactComponent };